import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 16px;
  padding-top: calc(${(props) => props.theme.layout.chat_header_height} + 16px);
`;

export const CanvasWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const TopUploadWrapper = styled.div`
  display: flex;
  z-index: 1;
  justify-content: flex-end;
  width: 100%;
`;
export const TopUploadButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding: 8px 16px 8px 8px;
    border-radius: 22px;
    background: ${theme.backgroundColor.bg_light_5_alpha};
    color: ${theme.content.content_light_3};
    gap: 4px;
    ${theme.fontStyle.text.body18_medium};
  `}
`;

export const BottomWrapper = styled.div`
  display: flex;
  z-index: 2;
  flex-direction: column;
  width: 100%;
  padding: 0 0 40px;
  gap: 16px;
`;

export const CardTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.24);
    ${theme.fontStyle.text.body18_medium};
  `}
`;

export const CharacterCardWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: auto;
  gap: 8px;
  ${(props) => props.theme.mixins.scroll.horizontal}
`;

export const CharacterUploadCard = styled.label`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80px;
    padding: 8px;
    border: 2px solid ${theme.stroke.stroke_1};
    border-radius: 16px;
    background: rgba(0, 0, 0, 0.6);
    gap: 8px;
    cursor: pointer;
  `}
`;

export const AiTag = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    left: 0;
    padding: 6px 8px 8px 6px;
    border-radius: 14px var(--radius_0, 0px) 16px var(--radius_0, 0px);
    background: ${theme.backgroundColor.bg_light_5_alpha};
    color: ${theme.content.content_light_1};
    gap: 8px;
  `}
`;

export const ExpressionItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 12px;
    border: 1px solid ${theme.content.caption2};
    border-radius: 18px;
    color: ${theme.content.caption2};
    ${theme.fontStyle.text.body18_medium};
    cursor: pointer;

    &.ex {
      border: 1px solid ${theme.themeColor.basic};
      color: ${theme.themeColor.basic};
    }

    &.on {
      border: 1px solid #47e9ff;
      color: #47e9ff;
    }
  `}
`;
